import { createContext } from 'react';

export const HeaderHeightContext = createContext(76);
